import { Injectable } from '@angular/core';
import { GenericStateService } from '../../generic-state/generic-state.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchStoreService {
   private stateSubject = new BehaviorSubject<any>(null);

    readonly state$: Observable<any> = this.stateSubject.asObservable();

  setEntities(entities: any) {
    this.stateSubject.next({
      ...entities
    });
    }
}
